import { render, staticRenderFns } from "./ManagerActivityItem.vue?vue&type=template&id=2f5d4ca8&scoped=true"
import script from "./ManagerActivityItem.vue?vue&type=script&lang=js"
export * from "./ManagerActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ManagerActivityItem.vue?vue&type=style&index=0&id=2f5d4ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d4ca8",
  null
  
)

export default component.exports